import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'pixelAspect';

export class PixelAspect extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
